<template>
  <div class="main-container">
    <div class="main-container-title-box">
      <div class="main-container-title-box-text">
        <span class="title-box-text"> Пункты меню </span>
      </div>
      <v-btn @click="goToCreate" style="width: 230px !important" class="button-accept">
        + Добавить пункт меню
      </v-btn>
    </div>
    <div class="table-container">
      <v-data-table :headers="tableHeaders" :items="appSections" item-key="id" :show-select="false"
        :disable-pagination="true" hide-default-header :hide-default-footer="true">
        <template v-slot:header>
          <thead>
            <tr>
              <th v-for="(s, index) in tableHeaders" :key="index">
                <div style="margin-left: 24px" v-if="s.text == 'Название'">
                  {{ s.text }}
                </div>

                <div v-else>
                  {{ s.text }}
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="props">
          <draggable :list="props.items" tag="tbody" @end="endDrag" :move="checkMove"
            :style="moveItems ? 'pointer-events: none;' : ''">
            <tr v-for="(item, index) in props.items" :key="index"
              :style="item.position == 1 ? 'pointer-events: none;' : ''">
              <td>
                <v-icon v-if="item.position != 1" small style="cursor: pointer" :disabled="moveItems ? true : false">
                  mdi-menu
                </v-icon>
              </td>
              <td style="max-width: 100px !important">{{ index + 1 }}</td>
              <td>
                <img style="width: 24px" :src="item.androidIcon" />
              </td>
              <td v-if="!item.isView && !item.isTestMod">
                <div class="d-flex align-center">
                  <v-icon small> mdi-eye-off </v-icon>
                  <div style="margin-left: 8px">{{ item.name }}</div>
                </div>
              </td>
              <td v-else-if="item.isView && item.isTestMode">
                <div class="d-flex align-center">
                  <v-icon small> mdi-alpha-t-box-outline </v-icon>
                  <div style="margin-left: 8px">{{ item.name }}</div>
                </div>
              </td>
              <td v-else-if="!item.isView && item.isTestMode">
                <div class="d-flex align-center">
                  <div class="d-flex flex-column">
                    <v-icon small>mdi-eye-off </v-icon>
                    <v-icon small> mdi-alpha-t-box-outline </v-icon>
                  </div>

                  <div style="margin-left: 8px">{{ item.name }}</div>
                </div>
              </td>

              <td v-else>
                <div class="d-flex align-center">
                  <div style="width: 24px"></div>
                  <div>{{ item.name }}</div>
                </div>
              </td>
              <td>
                <div>{{ item.shortName }}</div>
              </td>
              <td>
                <v-icon :style="item.position == 1 ? 'pointer-events: auto;' : ''" @click="goToEdit(item)"
                  style="cursor: pointer">
                  mdi-pencil-outline
                </v-icon>
              </td>
            </tr>
          </draggable>
        </template>
      </v-data-table>
    </div>
    <v-divider></v-divider>
  </div>
</template>
<script>

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
  },
  data: () => ({
    appSections: [],
    sortedNumbers: [],
    moveItems: false,
    selectedDrag: "",
    optionTable: {
      page: 1,
      itemsPerPage: 10,
      serverItemsLength: -1,
    },
    tableHeaders: [
      {
        text: "",
        sortable: false,
      },
      {
        text: "Порядок отображения",
        value: "",
        sortable: false,
      },
      {
        text: "Иконка",
        sortable: false,
      },
      {
        text: "Название",
        sortable: false,
      },
      {
        text: "Короткое название",
        sortable: false,
      },
      {
        text: "",
        sortable: false,
        value: "action",
        aligh: "right",
      },
    ],
  }),
  methods: {
    goToCreate() {
      this.$router.push({ name: "CreateAppSection" });
    },
    goToEdit(item) {
      this.$router.push({ name: "EditAppSection", params: { id: item.id } });
    },
    getAppSections() {
      this.$axios
        .post(
          this.$store.getters.apiAdminPanelV2 + "/appSection/list",
          {},
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then((res) => {
          this.appSections = res.data.items;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    endDrag(evt) {
      this.moveItems = true;
      this.$axios
        .put(
          this.$store.getters.apiAdminPanelV2 + "/appSection/sort",
          {
            sectionId: this.selectedDrag,
            position: evt.newIndex + 1,
          },
          {
            headers: {
              authorization: this.$store.getters.adminPanelHeaderAuth,
            },
          }
        )
        .then(() => {
          this.getAppSections();
          this.moveItems = false;
        })
        .catch((err) => {
          this.$store.commit("errorSet", true);
          this.$store.commit("errorTextSet", err);
        });
    },
    checkMove(evt) {
      this.selectedDrag = evt.draggedContext.element.id;
    },
  },
  created() {
    this.getAppSections();
  },
};
</script>
<style lang="scss" scoped>
.table-container {
  height: calc(100vh - 190px);
  overflow: auto;
}
</style>